import fetch from 'isomorphic-fetch';
import { toastsActions } from '@zola-helpers/client';

import {
  updateEntityRequest, receiveEntityResponse, receiveUpdatedEntityResponse, getEntitiesRequest,
  getEntitiesResponse, editEntityRequest, requestSuggestions, receiveSuggestions
} from '../EntityActions';

const ENTITY_LIST_NAME = 'faqs';

export function getSuggestedFaqs() {
  return (dispatch) => {
    dispatch(requestSuggestions());
    return fetch('/web-api/v1/cms/page/faq/suggestions',
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveSuggestions(json)));
  };
}

export function getFaqs() {
  return (dispatch) => {
    dispatch(getEntitiesRequest());
    return fetch('/web-api/v1/cms/page/faq',
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(getEntitiesResponse(json, ENTITY_LIST_NAME)));
  };
}

export const editFaq = faq => (dispatch) => {
  dispatch(editEntityRequest(faq));
};

export function addFaq(createFaqRequest) {
  return (dispatch) => {
    dispatch(updateEntityRequest());
    return fetch('/web-api/v1/cms/page/faq/create',
      {
        credentials: 'same-origin',
        headers: {
          'Content-type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(createFaqRequest)
      })
      .then(response => response.json())
      .then(json => dispatch(receiveEntityResponse(json)))
      .then(() => dispatch(toastsActions.positive({ headline: 'FAQ Added' })));
  };
}

export function updateFaq(updatedFaqRequest) {
  return (dispatch) => {
    dispatch(updateEntityRequest());
    return fetch('/web-api/v1/cms/page/faq/update',
      {
        credentials: 'same-origin',
        headers: {
          'Content-type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(updatedFaqRequest)
      })
      .then(response => response.json())
      .then(json => dispatch(receiveUpdatedEntityResponse(json)))
      .then(() => dispatch(toastsActions.positive({ headline: 'FAQ Updated' })));
  };
}



// WEBPACK FOOTER //
// ./src/actions/website/entities/FaqActions.js